/**
 * Nav du slider upsell fiche produit (flèches prev/next).
 * L'ajout au panier est géré par les <product-form-component> internes (auto-gérés par Horizon).
 */
class ProductUpsellComponent extends HTMLElement {
  connectedCallback() {
    this.slider = this.querySelector('[data-upsell-slider]');
    this.prevBtn = this.querySelector('[data-upsell-prev]');
    this.nextBtn = this.querySelector('[data-upsell-next]');
    if (!this.slider) return;

    this.prevBtn?.addEventListener('click', () => this.#scroll(-1));
    this.nextBtn?.addEventListener('click', () => this.#scroll(1));
    this.slider.addEventListener('scroll', () => this.#updateButtons(), { passive: true });

    this.#updateButtons();
  }

  #scrollAmount() {
    // ~ largeur d'une carte + gap
    const card = this.slider.querySelector('.product-upsell__card');
    const gap = 12;
    return card ? card.offsetWidth + gap : 300;
  }

  #scroll(direction) {
    this.slider.scrollBy({ left: direction * this.#scrollAmount(), behavior: 'smooth' });
  }

  #updateButtons() {
    if (!this.prevBtn || !this.nextBtn) return;
    const max = this.slider.scrollWidth - this.slider.clientWidth;
    this.prevBtn.disabled = this.slider.scrollLeft <= 1;
    this.nextBtn.disabled = this.slider.scrollLeft >= max - 1;
  }
}

if (!customElements.get('product-upsell-component')) {
  customElements.define('product-upsell-component', ProductUpsellComponent);
}
